import { useLocation } from 'react-use'
import { parse } from 'query-string'

export function useQueryParams<K extends string>(): Partial<{ [key in K]: string | string[] | undefined }> {
  const location = useLocation()
  const queryString = location.hash?.split('?')[1] || ''

  return parse(queryString) as any
}
